<div class="card-body">

  <form>

    <div class="row">

      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">Has the customer requested a specific calibration method?</label>
        <select class="custom-select" [(ngModel)]="s1" name="s1">
          <option value="1">Yes</option>
          <option value="0">No</option>
        </select>
      </div>

      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">Are subcontractor services required? </label>
        <select class="custom-select" [(ngModel)]="s2" name="s2">
          <option value="1">Yes</option>
          <option value="0">No</option>
        </select>
      </div>

    </div>

    <div class="row" [hidden]="s1=='0'">

      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">What method or standard has the customer proposed?</label>
        <textarea class="form-control" [(ngModel)]="s1_1" name="s1_1"
          placeholder="Type here..."></textarea>
      </div>

      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">Are the requested method procedure and required resources available at Behineh Laboratory? </label>
        <select class="custom-select" [(ngModel)]="s1_2" name="s1_2">
          <option value="1">Yes</option>
          <option value="0">No</option>
        </select>
      </div>

    </div>

    <div class="row">

      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">Can the work be performed and delivered within the customer's requested timeframe? </label>
        <select class="custom-select" [(ngModel)]="s3" name="s3">
          <option value="1">Yes</option>
          <option value="0">No</option>
        </select>
      </div>

      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">Is accepting this request financially viable for the company? </label>
        <select class="custom-select" [(ngModel)]="s4" name="s4">
          <option value="1">Yes</option>
          <option value="0">No</option>
        </select>
      </div>

    </div>

    <div class="row">

      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">Does the request comply with legal requirements and company policies? </label>
        <select class="custom-select" [(ngModel)]="s5" name="s5">
          <option value="1">Yes</option>
          <option value="0">No</option>
        </select>
      </div>

      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">Can Behineh Laboratory calibrate all requested equipment? </label>
        <select class="custom-select" [(ngModel)]="s6" name="s6">
          <option value="1">Yes</option>
          <option value="0">No</option>
        </select>
      </div>

    </div>

    <div class="row">

      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">Can a subcontractor calibrate all requested equipment? </label>
        <select class="custom-select" [(ngModel)]="s7" name="s7">
          <option value="0">Yes — Not Required at Present</option>
          <option value="1">Yes — The Customer Will Be Notified</option>
          <option value="2">No</option>
        </select>
      </div>

      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">Is calibration unavailable for any of the equipment?</label>
        <select class="custom-select" [(ngModel)]="s8" name="s8">
          <option value="1">Yes</option>
          <option value="0">No</option>
        </select>
      </div>

    </div>

    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">The customer request will be declined for the following reasons:</label>
        <textarea class="form-control" [(ngModel)]="s9" name="s9"
          placeholder="Type here..."></textarea>
      </div>
    </div>

    <br />
    <br />
    <br />

    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!InProccessing" (click)="OnSubmit()" type="button" class="btn btn-success"
      style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>


  </form>



</div>
